import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CdkPopupBase } from 'projects/shared/src/lib/components/cdk-popup/cdk-popup.base';
import { POPUP_DEFAULTS } from 'projects/shared/src/lib/core/constants/global-constants';
import { IconButtonComponent } from 'projects/shared/src/ui-kit/button/components/icon-button/icon-button.component';
import { environment } from '../../environments/environment';

export enum BulkDeletePopupResult {
  Understood = 'understood',
  KnowledgeBase = 'knowledge-base',
}

@Component({
  selector: 'app-bulk-delete-popup',
  imports: [TranslatePipe, IconButtonComponent],
  templateUrl: './bulk-delete-popup.component.html',
  styleUrl: './bulk-delete-popup.component.scss',
})
export class BulkDeletePopupComponent extends CdkPopupBase<BulkDeletePopupResult> {
  public readonly POPUP_DEFAULTS = POPUP_DEFAULTS;

  public onGoToKnowledgeBase(): void {
    window.open(environment.lexipoort.knowledgeBase);
  }

  public onUnderstood(): void {
    this.close(BulkDeletePopupResult.Understood);
  }
}
